import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';
import { ISPSelectModule } from 'components/select/select.module';

import { ISPUIInputModule } from '@ispui/ng-input';

import { FormIdPrefixModule } from 'common/form-id-prefix/form-id-prefix.module';

import { PhoneComponent } from './phone.component';

import { ISPFieldType } from '../../model';

@NgModule({
  declarations: [PhoneComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ISPSelectModule,
    FormIdPrefixModule,
    ISPUIInputModule,
    FormlyModule.forChild({
      types: [
        {
          name: ISPFieldType.Phone,
          component: PhoneComponent,
        },
      ],
    }),
  ],
})
export class PhoneModule {}
